// src/components/ScrollToHash.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    // ハッシュ（#services みたいなやつ）が付いていれば…
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);

      if (el) {
        // その要素までスクロール
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // ハッシュがないときはページトップに戻す
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  return null; // 画面には何も描画しない
}
